import * as React from 'react';
import { User } from '../../../models';
import { FilterStore } from '../../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { PVASelect, PVASelectOption } from './PVASelect';

interface PVAMultiSelectProps<T extends { id: number }> {
    defaultOptions?: any[];
    options: T[];
    selected: number[];
    onChange: Function;
    FilterStore?: FilterStore;
    itemLabel?: string;
    renderOption?: (option: T) => React.ReactNode;
    sortOptions?: (a: T, b: T) => number;
    disabled?: boolean;
}

@inject('FilterStore') @observer
export class PVAMultiSelect<T extends { id: number }> extends React.Component<PVAMultiSelectProps<T>, {}> {
    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    render() {
        const options = this.props.options.map(o => ({
            id: o.id,
            label: (o as any).label || (o as any).name || o.id.toString(),
            original: o
        }));

        return (
            <PVASelect
                isMulti={true}
                options={options}
                selected={this.props.selected}
                onChange={this.props.onChange}
                defaultOptions={this.props.defaultOptions}
                noSelectTitle={this.props.itemLabel}
                sortOptions={this.props.sortOptions ? (a, b) => this.props.sortOptions!((a as any).original, (b as any).original) : undefined}
                disabled={this.props.disabled}
                renderOption={(opt: PVASelectOption) => {
                    const original = (opt as any).original;
                    return this.props.renderOption ? this.props.renderOption(original) : <span>{opt.label}</span>;
                }}
            />
        );
    }
}

interface UserMultiSelectProps {
    defaultOptions?: any[];
    options: User[];
    selected: number[];
    onChange: Function;
    FilterStore?: FilterStore;
    disabled?: boolean;
}

@inject('FilterStore') @observer
export class UserMultiSelect extends React.Component<UserMultiSelectProps, {}> {
    private sortUsers(a: User, b: User): number {
        if (a.lastName > b.lastName) {
            return 1;
        } else if (a.lastName < b.lastName) {
            return -1;
        }
        if (a.firstName > b.firstName) {
            return 1;
        } else if (a.firstName < b.firstName) {
            return -1;
        }

        return 0;
    }

    render() {
        return (
            <PVAMultiSelect
                {...this.props}
                itemLabel="Team Members"
                sortOptions={this.sortUsers}
                renderOption={(user: User) => (
                    <span>{user.lastName}, {user.firstName}</span>
                )}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAMultiSelect.tsx